import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, DollarSign, CheckCircle2, ArrowRight } from 'lucide-react';
const creditFeatures = ['Revision de reporte de credito', 'Estrategia de disputa personalizada', 'Plan de mejora de puntuacion y asesoramiento', 'Monitoreo continuo de credito y actualizacion en cada ronda'];
const fundingFeatures = ['Personal Loans', 'Business Credit Cards', 'Credit Stacking'];
export function Services() {
  return <section id="servicios" className="bg-black py-20 md:py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-218" data-mp="z54twr53t9e2">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(245,158,11,0.05),transparent_50%)] pointer-events-none" data-id="element-219" data-mp="u5a30nlbwjt0" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-220" data-mp="q6b0f9n2kz4q">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-14 md:mb-16" data-id="element-221" data-mp="l5myvu17szw9">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-222" data-mp="2xd2td80bn7en">
            Nuestros Servicios
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-223" data-mp="3q18evwz790fj">
            Dos Pilares,{' '}
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-224" data-mp="3g29gd785el69">
              Un Solo Objetivo
            </span>
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-225" data-mp="24ndrksfsf3bz">
            Optimizamos tu credito y conseguimos el capital que necesitas, todo
            con un servicio completamente personalizado.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-226" data-mp="1pjb01u24oe1h">
          {/* Service 01 — Credit */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col p-8 md:p-10 rounded-3xl bg-gradient-to-b from-white/[0.04] to-white/[0.01] border border-white/[0.08]" data-id="element-227" data-mp="1ljakg63alwsu">
            <div className="flex items-center gap-4 mb-8" data-id="element-228" data-mp="sud2y56wo415">
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/20 flex items-center justify-center" data-id="element-229" data-mp="svwni7zlh18q">
                <TrendingUp className="h-7 w-7 text-amber-400" strokeWidth={2} data-id="element-230" data-mp="2n95yy5bpawtm" />
              </div>
              <span className="text-sm font-semibold tracking-[0.25em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-231" data-mp="2zqgpuf1zims1">
                Servicio 01
              </span>
            </div>

            <h3 className="text-3xl md:text-4xl font-bold text-white mb-5" data-id="element-232" data-mp="39gjg47hq1mmo">
              Optimizacion de{' '}
              <span className="italic bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-233" data-mp="2btjdqm4fsf4b">
                Credito
              </span>
            </h3>
            <p className="text-white/50 font-light leading-relaxed mb-8" data-id="element-234" data-mp="2lqfnsw9zh9az">
              Revisamos tu reporte de credito y diseñamos una estrategia
              totalmente personalizada para ti, con el objetivo de restaurarlo,
              optimizarlo y hacerlo atractivo para los bancos y demas
              instituciones financieras para conseguir capital personal o para
              tu negocio.
            </p>

            <ul className="space-y-4 mb-10 flex-grow" data-id="element-235" data-mp="3lo0pfl927ek">
              {creditFeatures.map((feature, i) => <li key={i} className="flex items-center gap-3" data-id="element-236" data-mp="3usqsa8502fpb" data-mpi={i}>
                  <CheckCircle2 className="h-5 w-5 text-amber-400 shrink-0" strokeWidth={2} data-id="element-237" data-mp="djc6d0ke8zbi" />
                  <span className="text-white/70 font-light" data-id="element-238" data-mp="8m2b34abptfr">{feature}</span>
                </li>)}
            </ul>

            <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-semibold bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent group" data-id="element-239" data-mp="hkxj8lwxhdlp">
              Quiero optimizar mi credito
              <ArrowRight className="h-4 w-4 text-amber-400 group-hover:translate-x-1 transition-transform" data-id="element-240" data-mp="157vtv2yd9rbp" />
            </a>
          </motion.div>

          {/* Service 02 — Funding (highlighted) */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          delay: 0.15,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col p-8 md:p-10 rounded-3xl bg-gradient-to-b from-amber-500/[0.06] to-transparent border border-amber-500/30 shadow-2xl shadow-amber-500/5" data-id="element-241" data-mp="1jv4aijag2ov2">
            <div className="flex items-center gap-4 mb-8" data-id="element-242" data-mp="w7cmiifjkndy">
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/30 flex items-center justify-center" data-id="element-243" data-mp="w7w3nwxdb7qx">
                <DollarSign className="h-7 w-7 text-amber-400" strokeWidth={2} data-id="element-244" data-mp="n6xz9dj0oy7t" />
              </div>
              <span className="text-sm font-semibold tracking-[0.25em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-245" data-mp="2oxyihr80i8gd">
                Servicio 02
              </span>
            </div>

            <h3 className="text-3xl md:text-4xl font-bold text-white mb-5" data-id="element-246" data-mp="2b4pb1w3mjx0h">
              Funding{' '}
              <span className="italic bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-247" data-mp="37ug3lpscva3n">
                Solutions
              </span>
            </h3>
            <p className="text-white/50 font-light leading-relaxed mb-8" data-id="element-248" data-mp="2yu1kmx2v673b">
              Luego de optimizar tu reporte de credito, diseñamos estrategias
              personalizadas para conseguir el capital que necesitas sea para ti
              personalmente o para tu negocio.
            </p>

            {/* Capital range highlight box */}
            <div className="rounded-2xl border border-amber-500/20 bg-black/40 p-6 mb-8" data-id="element-249" data-mp="1if0a1iqwzwyv">
              <div className="text-xs font-semibold tracking-[0.2em] uppercase text-white/40 mb-3" data-id="element-250" data-mp="18cw88rg2o62u">
                Nos centramos en buscar capital que va de entre
              </div>
              <div className="flex items-baseline justify-center gap-3 whitespace-nowrap" data-id="element-251" data-mp="1i9r5z84iu2g2">
                <span className="text-2xl md:text-3xl font-bold bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-252" data-mp="1n199a2u0of47">
                  $35,000
                </span>
                <span className="text-sm font-light text-white/40" data-id="element-253" data-mp="1w0w76enjf2si">a</span>
                <span className="text-2xl md:text-3xl font-bold bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-254" data-mp="210imququ8v4h">
                  $50,000
                </span>
                <span className="text-xs font-semibold tracking-[0.15em] text-white/40" data-id="element-255" data-mp="6mr5b929p6yh">
                  USD
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-10 flex-grow" data-id="element-256" data-mp="bnompjfgdwyx">
              {fundingFeatures.map((feature, i) => <li key={i} className="flex items-center gap-3" data-id="element-257" data-mp="2dgrt89e7um8i" data-mpi={i}>
                  <CheckCircle2 className="h-5 w-5 text-amber-400 shrink-0" strokeWidth={2} data-id="element-258" data-mp="28ji6j1i7oood" />
                  <span className="text-white/70 font-light" data-id="element-259" data-mp="2ia336jebrj4n">{feature}</span>
                </li>)}
            </ul>

            <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-semibold bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent group" data-id="element-260" data-mp="1ulbdpzs4devk">
              Quiero acceder a financiamiento
              <ArrowRight className="h-4 w-4 text-amber-400 group-hover:translate-x-1 transition-transform" data-id="element-261" data-mp="3ezkfhh7tc3fb" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}